import 'material-icons/iconfont/material-icons.css';
import React from 'react';
import { ArticleSearchInput, ArticleSearchResults, ArticleSearchResult, ArticleSearchInputContainer, ArticleSearchIcon } from './ArticleSearch.styles';
import { useGetGhostArticlesTitlesSlugs } from '../../hooks/useGetGhostArticlesTitlesSlugs';

var ArticleSearch = function ArticleSearch(_ref) {
  var ghostApi = _ref.ghostApi,
      domain = _ref.domain;

  var _React$useState = React.useState([]),
      searchResults = _React$useState[0],
      setSearchResults = _React$useState[1];

  var articles = useGetGhostArticlesTitlesSlugs(ghostApi);

  var _onChange = function onChange(newSearchTerm) {
    if (!newSearchTerm) {
      setSearchResults([]);
      return;
    }

    var results = articles.filter(function (article) {
      return article.title.toLowerCase().includes(newSearchTerm.toLowerCase());
    });
    setSearchResults(results);
  };

  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(ArticleSearchInputContainer, null, /*#__PURE__*/React.createElement(ArticleSearchIcon, {
    className: "material-icons-outlined"
  }, "search"), /*#__PURE__*/React.createElement(ArticleSearchInput, {
    type: "text",
    placeholder: "Search",
    onChange: function onChange(e) {
      return _onChange(e.target.value);
    }
  })), /*#__PURE__*/React.createElement(ArticleSearchResults, null, searchResults.map(function (article) {
    return /*#__PURE__*/React.createElement(ArticleSearchResult, {
      key: article.slug,
      href: domain + "/articles/" + article.slug
    }, article.title);
  })));
};

export default ArticleSearch;